import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../config/hooks';
import { getAllFollowUpsApi, getfilteredClientsApi } from '../../slices/salesSlice';
import ReactQuill from 'react-quill';
import { Link } from 'react-router-dom';
import SearchIcon from '../../assets/Icons/SearchIcon';

const FollowUp = () => {
  // const companyId = '7265175386428186624'; 
  const dispatch=useAppDispatch()
  const {clientDetail,followUps}=useAppSelector((state)=>state.sales)
  const {salesEngageWith}=useAppSelector((state)=>state.appConfig)

  const [interactions, setInteractions] = useState([]);
  const [filters, setFilters] = useState({
    companyId:'',
    status: '',
    stages:'',
    // subStages: '',
    search: '',
    startDate:   new Date().toISOString().slice(0, 10) ||'',
    endDate: '',
    client_id:''
  });


    // Set default companyId once salesEngageWith is loaded
    useEffect(() => {
      if (salesEngageWith?.length > 0 && !filters.companyId) {
        setFilters((prev) => ({
          ...prev,
          companyId: salesEngageWith[0].value
        }));
      }
    }, [salesEngageWith]);

  // const fetchData = async () => {
  //   try {
  //     const params = new URLSearchParams(
  //       Object.entries(filters).filter(([, value]) => value !== '')
  //     );
      
       
  //     dispatch(getAllFollowUpsApi({companyId:filters.companyId ,...filters})).then(()=> setInteractions(followUps.followUps))
  //     // const res = await axios.get(`/v1/exo/company/${companyId}/interactions?${params}`);
  //     // setInteractions(res.data);
  //   } catch (error) {
  //     console.error('Failed to fetch interactions:', error);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, [filters]);

  const fetchData = async () => {
    try {
      dispatch(getAllFollowUpsApi({ companyId: filters.companyId, ...filters }))
        
    } catch (error) {
      console.error('Failed to fetch interactions:', error);
    }
  };

  useEffect(() => {
    if (filters.companyId) {
      fetchData();
    }
  }, [filters]);

  return (
    <div className="">
      {/* <h1 className="text-2xl font-bold mb-4">Interaction History</h1> */}
      <InteractionFilters filters={filters} onChange={setFilters} />
      <InteractionTable interactions={followUps.followUps} />
    </div>
  );
}

export default FollowUp;





type AuthorDetails = {
  firstName: string;
  lastName: string;
  profileImage: string;
  designation: string;
  reportingManager: string;
  companyId: string;
  jobProfile: string;
};

type InteractionProps = {
  id: string;
  clientId: string;
  clientName: string;
  interactionType: string;
  interactionDate: string;
  stages: string;
  purpose: string;
  remarks: string;
  nextFollowUpDate: string;
  authorId: string;
  authorType: string;
  authorDetails: AuthorDetails;
};

const getInteractionTypeLabel = (type: string) => {
  const map: Record<string, string> = {
    '1': 'Email',
    '2': 'Phone Call',
    '3': 'Meeting',
  };
  return map[type] || 'Other';
};

export const InteractionTable: React.FC<{ interactions: InteractionProps[] }> = ({ interactions }) => {


  // console.log(interactions,"DDDDD")

  // return 
  return (
    <div className="overflow-x-auto  ">
      <table className="min-w-full border border-gray-200 text-sm">
        <thead className="bg-primary-500 text-white text-nowrap">
          <tr>
            <th className="p-3 border">S.No.</th>
            <th className="p-3 border">Next Follow-Up</th>
            <th className="p-3 border">Interaction Date</th>
            <th className="p-3 border">Client</th>
            <th className="p-3 border">Interaction Type</th>
            {/* <th className="p-3 border">Stage</th> */}
            <th className="p-3 border">Purpose</th>
            <th className="p-3 border">Remarks</th>
            <th className="p-3 border">Author</th>
          </tr>
        </thead>
        <tbody className='text-exgray-600'>
          {interactions?.map((item,index) => (
            <tr key={item.id} className="hover:bg-gray-50 text-center">
              <td className="p-3 border">{index+1}</td>
              <td className="p-3 border ">{new Date(item.nextFollowUpDate).toLocaleDateString()}</td>
              <td className="p-3 border">{new Date(item.interactionDate).toLocaleDateString()}</td>
              <td className="p-3 border  text-nowrap">
                <Link to={`/company-admin/sales/detail/${item.clientId}`} className='hover:text-primary-400'>
                  {item.clientName}
                </Link>
                </td>
              <td className="p-3 border  text-nowrap">{getInteractionTypeLabel(item.interactionType)}</td>
              {/* <td className="p-3 border">{item.stages}</td> */}
              <td className="p-3 border  text-nowrap">{item.purpose}</td>
              <td className="p-3 border  min-w-36">
                                          {/* <div className='line-clamp-2'>
                                            <ReactQuill
                                              // style={{ }}
                                              value={item?.remarks}
                                              readOnly={true}
                                              theme={"bubble"}
                                              className=''
                                            />
                                          </div>                   */}
                                          <div
                                            className="line-clamp-1 "
                                            dangerouslySetInnerHTML={{ __html: item.remarks }}
                                          />
              </td>
              <td className="p-3 border  text-nowrap">
                <div className="flex items-center justify-center space-x-2">
                  {/* <img
                    src={item.authorDetails.profileImage}
                    alt="Profile"
                    className="w-8 h-8 rounded-full object-cover"
                  /> */}
                  <div>
                    <div className="font-medium">
                      {item.authorDetails.firstName} {item.authorDetails.lastName}
                    </div>
                    {/* <div className="text-xs text-gray-500">{item.authorDetails.jobProfile}</div> */}
                  </div>
                </div>
              </td>
            </tr>
          ))}
          {!interactions  && (
            <tr>
              <td colSpan={8} className="p-4 text-center text-gray-500">
                Not found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};




// FILTERS

type Filters = {
  companyId:string;
  status: string;
  client_id:string;
  stages: string;
  // subStages: string;
  search: string;
  startDate: string;
  endDate: string;
};

type Props = {
  filters: Filters;
  onChange: (filters: Filters) => void;
};

export const InteractionFilters: React.FC<Props> = ({ filters, onChange }) => {
  const dispatch = useAppDispatch();
  const {salesEngageWith}=useAppSelector((state)=>state.appConfig)
  const {clients} =useAppSelector((state) => state.sales);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [search, setSearch] = useState("");
 
  
  

    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const searchContainerRef = useRef<HTMLDivElement>(null);
  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  //   onChange({ ...filters, [e.target.name]: e.target.value });
  // };


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target as Node)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
  
    let updatedValue = value;
  
    // Convert date input to ISO UTC string
    if ((name === 'startDate' || name === 'endDate') && value) {
      updatedValue = new Date(value).toISOString();
    }
  
    onChange({ ...filters, [name]: updatedValue });
  };


   const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.toLowerCase();
      setSearch(value);

      console.log(value.length,"VALUE",value)
      console.log("SEARCH",search)

       if(value.length<=0){
        filters.client_id=''
        filters.search=''
        dispatch(getAllFollowUpsApi({ companyId: filters.companyId, ...filters }))

        setDropdownVisible(false);
        return
       }
      setDropdownVisible(true);

      // Clear the previous timeout if it exists
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      timeoutRef.current = setTimeout(() => {
        dispatch(getfilteredClientsApi({ search: value }));
      }, 500); 
  
    };


    // console.log(filteredClients,"CJEKDJ")
  return (
    <div className="flex items-center flex-wrap gap-2 mb-4 ">
      {/* <input
        type="text"
        name="search"
        placeholder="Search"
        className="input  w-full md:w-48 px-2 border border-gray-300 rounded-md"
        value={filters.search}
        onChange={handleChange}
      /> */}
         <div className='relative' ref={searchContainerRef}>
            <input
              type="text"
              placeholder="Search ..."
              value={search}
              onChange={handleSearch}
              className="border border-gray-300 rounded-md pl-8 pr-4 py-1 w-44 focus:outline-none "
              />
            <div className="absolute top-2 pl-1">
              <SearchIcon />
            </div>

            {isDropdownVisible && (
          <div className="bg-exgray-700/90 absolute w-full max-h-[10rem] overflow-y-auto text-white z-10 rounded shadow">
            {clients && clients.clients?.length > 0 ? (
              clients.clients.map((item) => (
                <h1
                  // key={item.clientId}
                  className="p-1 hover:bg-primary-400 cursor-pointer"
                  onClick={() => {
                    onChange({ ...filters, client_id: item.id });
                    setSearch(item.clientName);
                    setDropdownVisible(false);
                  }}
                >
                  {item.clientName}
                </h1>
              ))
            ) : (
              <h1 className="py-1 text-center">Not Found</h1>
            )}
          </div>
        )}
          </div>
    <div>

        <select
            name="companyId"
            value={filters.companyId}
            // defaultValue={salesEngageWith[0].value}
            onChange={handleChange}
            className="border border-gray-300 rounded-md py-1 w-28"
            >
            <option disabled value="">Engage With</option>
            {/* <option  value="">All</option> */}
            {salesEngageWith.map((eng, index) => (
              <option key={index} value={eng.value}>
                {eng.Title}
              </option>
            ))}
            
        </select>
    </div>
      {/* <input type="text" name="stages" placeholder="Stage" className="input input-bordered w-full md:w-40" value={filters.stages} onChange={handleChange} /> */}
      {/* <input type="text" name="subStages" placeholder="Sub-Stage" className="input input-bordered w-full md:w-40" value={filters.subStages} onChange={handleChange} /> */}
      {/* <input type="text" name="client_id" placeholder="ClientId" className="input input-bordered w-full md:w-40" value={filters.client_id} onChange={handleChange} /> */}
      <div className=' items-center flex gap-1'>
        <label className=''>From:</label>
        <input type="date" name="startDate" className="input input-bordered w-full md:w-40 px-2 py-1 border border-gray-300 rounded-md" value={filters.startDate  ? filters.startDate.slice(0, 10) :  new Date().toISOString().slice(0, 10)} onChange={handleChange} />
      </div>
      <div className=' items-center flex gap-1'>
        <label className=''>To</label>
        <input  min={filters.startDate ? filters.startDate.slice(0, 10) :   new Date().toISOString().slice(0, 10)}  type="date" name="endDate" className="input input-bordered w-full md:w-40 px-2 py-1 border border-gray-300 rounded-md" value={filters.endDate ? filters.endDate.slice(0, 10) : ''} onChange={handleChange} />
      </div>
      <select
        name="stages"
        className="select select-bordered w-full md:w-40 py-1"
        value={filters.stages}
        onChange={handleChange}
        defaultValue={""}
      >
        <option value={""} disabled >Select FollowType</option>
        <option value="1">Interaction FollowUps</option>
        <option value="2">Onboarding FollowUps</option>
        <option value="">All</option>
        {/* <option value="all">All</option> */}
        {/* Add more stages as needed */}
      </select>
    
    </div>
  );
};


